import script from "./ProjectAddRoleDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAddRoleDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAddRoleDropdown.vue?vue&type=style&index=0&id=2054570b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2054570b"]])

export default __exports__